import { useEffect } from 'react';

import { usePremarketplaceContext } from '~/provider/PremarketplaceProvider';
import { useStepContext } from '~/provider/StepProvider';

// Premarketplace step data lives in React state only, so a deep link or a
// mid-journey reload lands on a later step with everything the customer
// entered gone. Submitting from that state produces an invalid lead payload
// (INT-1134: "cannot send quote requests"), so restart the journey instead.
//
// `location` is the anchor because an address is required by every lead
// submit, whatever else the flow collects: being past it without an address
// can only mean the state was lost. Its index is looked up in the active
// flow's config, so flows may order steps freely (and may write other state
// before it); a flow with no location step disables the guard entirely
// (fail open) rather than guessing at a different marker.
export const JourneyStateGuard = () => {
  const { formData } = usePremarketplaceContext();
  const { config, currentStepIndex, resetSteps } = useStepContext();

  const steps = config?.steps;
  const hasAddress = Boolean(formData?.selectedAddress);

  useEffect(() => {
    if (!steps?.length) {
      return;
    }
    const locationIndex = steps.findIndex((step) => step.id === 'location');
    if (locationIndex !== -1 && currentStepIndex > locationIndex && !hasAddress) {
      resetSteps();
    }
  }, [steps, currentStepIndex, hasAddress, resetSteps]);

  return null;
};
